var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { ThemeProvider } from "styled-components";
import { DoconRadio } from '../doconRadioButton/DoconRadioButton';
import { Body1, Body2 } from '../doconHeadings/doconHeadings';
import { BaseBox, FlexBox } from '../../shared/Element';
import WithDynamicTopMargin from '../../shared/WithDynamicTopMargin';
import { doconTheme } from "../../../theme/default";
var handleColors = function (_a) {
    var theme = _a.theme, checked = _a.checked, disabled = _a.disabled;
    var _b = theme.v2.colors, _c = _b.input, borderColor = _c.borderColor, hoverBgColor = _c.hoverBgColor, focusBorderColor = _c.focusBorderColor, disabledColor = _b.disabled;
    return "\n    --border-color: " + borderColor + ";\n    --hover-bg-color: " + hoverBgColor + ";\n\n    " + (checked ? "\n      --border-color: " + focusBorderColor + ";\n    " : '') + "\n\n    " + (disabled ? "\n      --hover-bg-color: " + disabledColor.bgColor + ";\n      cursor: not-allowed;\n      background-color: " + disabledColor.bgColor + ";\n    " : '') + "\n  ";
};
var Box = styled(BaseBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  min-width: 200px;\n  padding: 12px;\n  cursor: pointer;\n  border-radius: 8px;\n  border: solid 1px var( --border-color);\n\n  ", ";\n\n  :hover {\n    background-color: var( --hover-bg-color);\n  }\n\n  ", " {\n    float: ", ";\n    label { \n      width: 20px;\n      padding-left: 20px !important;\n      overflow: hidden;\n    }\n  }\n"], ["\n  position: relative;\n  min-width: 200px;\n  padding: 12px;\n  cursor: pointer;\n  border-radius: 8px;\n  border: solid 1px var( --border-color);\n\n  ", ";\n\n  :hover {\n    background-color: var( --hover-bg-color);\n  }\n\n  ", " {\n    float: ", ";\n    label { \n      width: 20px;\n      padding-left: 20px !important;\n      overflow: hidden;\n    }\n  }\n"])), function (props) { return handleColors(props); }, DoconRadio, function (_a) {
    var $place = _a.$place;
    return "" + ($place === 'right' ? 'right' : 'unset');
});
var HocBox = WithDynamicTopMargin(Box);
function TileRadio(_a) {
    var marginBetweenTop = _a.marginBetweenTop, value = _a.value, _b = _a.place, place = _b === void 0 ? 'right' : _b, checked = _a.checked, disabled = _a.disabled, children = _a.children, onClick = _a.onClick, props = __rest(_a, ["marginBetweenTop", "value", "place", "checked", "disabled", "children", "onClick"]);
    function handleClick() {
        onClick && onClick(value);
    }
    var radio = React.createElement(DoconRadio, { option: { value: value, label: '-' }, checked: checked });
    return (React.createElement(ThemeProvider, { theme: doconTheme },
        React.createElement(HocBox, __assign({ marginBetweenTop: marginBetweenTop, checked: checked, "$place": place, disabled: disabled, onClick: handleClick }, props), place === 'left' ? (React.createElement(FlexBox, { gap: '8px' },
            radio,
            React.createElement(BaseBox, { flex: 1 }, children))) : (React.createElement(React.Fragment, null,
            radio,
            children)))));
}
function TileRadioGroup(_a) {
    var name = _a.name, _b = _a.place, place = _b === void 0 ? 'right' : _b, selected = _a.selected, options = _a.options, onChange = _a.onChange, marginBetweenTop = _a.marginBetweenTop, props = __rest(_a, ["name", "place", "selected", "options", "onChange", "marginBetweenTop"]);
    var handleClick = function (value) {
        onChange && onChange({ name: name, value: value });
    };
    return (React.createElement(ThemeProvider, { theme: doconTheme },
        React.createElement(FlexBox, __assign({ gutter: 12 }, props), options.map(function (option, index) { return (React.createElement(TileRadio, { key: option.value, value: option.value, place: place, marginBetweenTop: marginBetweenTop, disabled: option.disabled, checked: selected === option.value, onClick: !option.disabled && handleClick },
            option.icon && React.createElement("p", null, option.icon),
            React.createElement(Body1, { color: 'currentColor', title: option.title }),
            React.createElement(Body2, { color: 'currentColor', mt: '5px', title: option.text }),
            option.customContent)); }))));
}
var DoconTileRadioGroup = styled(TileRadioGroup)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var DoconTileRadio = styled(TileRadio)(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
export { DoconTileRadioGroup, DoconTileRadio };
var templateObject_1, templateObject_2, templateObject_3;
